import {StateContext} from '@ngxs/store';
import {SearchQueryParams} from '../models/search-query-params.model';
import {SearchList} from '../models/search-list.model';
import {EMPTY, Observable} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {HttpResponse} from '@angular/common/http';

export const handleFetchListPage = (
    ctx: StateContext<any>,
    searchQueryParams: SearchQueryParams,
    callback: (props: SearchQueryParams) => Observable<any>,
    listPath = 'list'
) => {
    let state = ctx.getState();
    const orderByField = searchQueryParams?.orderByField || state[listPath].orderByField;
    const orderDirection = searchQueryParams?.orderDirection || state[listPath].orderDirection;
    ctx.patchState({
        [listPath]: {
            ...state[listPath],
            loading: true,
        }
    });
    const props = new SearchQueryParams({
        orderByField, orderDirection, filters: state[listPath].filters.model
    });
    return callback(props).pipe(
        tap(({items}: SearchList<any>) => {
            state = ctx.getState();
            ctx.patchState({
                [listPath]: {
                    ...state[listPath],
                    items: [...items],
                    loading: false,
                    error: false,
                    orderByField,
                    orderDirection,
                }
            });
        }),
        catchError(() => {
            ctx.patchState({
                [listPath]: {
                    ...state[listPath],
                    loading: false,
                    error: true,
                    items: [],
                }
            });
            return EMPTY;
        })
    );
};

export function mapSearchListResponse<T>(typeCreator: new(t: T) => T) {
    return map((response: HttpResponse<T[]>) => new SearchList<T>({
        items: response.body.map(item => new typeCreator(item)),
    }));
}

export const handleFilters = (
    ctx: StateContext<any>,
    searchQueryParams: SearchQueryParams,
    callback: (props: SearchQueryParams) => Observable<any>,
    listPath = 'list'
) => {
    const state = ctx.getState();
    const props = new SearchQueryParams({
        filters: state[listPath].filters.model
    });
    return callback(props);
};
